export default __webpack_public_path__ + "static/media/space3.7599005d.png";